module.exports = __webpack_public_path__ + "img/02-01-img-02.02ed9899.png";